// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] || chunkId) + "-" + {"223":"b8cfa323d2929315dd88","230":"9a04307207f150a8a3d4","256":"4e0ebdb833305bed61cb","532":"0da30c4868f80da13552","843":"ec4302638027797cca24"}[chunkId] + ".js";
};